<template>
<div id="app_container">

    <!-- toolbar -->
    <v-toolbar dense flat tabs color="primary">
        <v-toolbar-title class="major white--text">
            Manager
        </v-toolbar-title>
        <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp" class="ml-3">
            <v-tabs background-color="primary" dark class="regular my-extension white--text ">
                <v-tabs-slider color="white"></v-tabs-slider>
                <v-tab class="text-capitalize font-weight-bold" :to="{path:'/dashboard'}">Dashboard</v-tab>
                <v-tab class="text-capitalize font-weight-bold" :to="{path:'/hotels'}">Hotels</v-tab>
                <v-tab class="text-capitalize font-weight-bold" :to="{path:'/reservations'}">Reservations</v-tab>
                <v-tab class="text-capitalize font-weight-bold" :to="{path:'/invoices'}">Invoices</v-tab>
                <v-tab class="text-capitalize font-weight-bold" :to="{path:'/reports'}">Reports</v-tab>
            </v-tabs>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <im-app-selector />
        <im-language-selector :use="['en', 'ro']" select="en" @input="changeLocale($event)" />
        <im-profile />
    </v-toolbar>
    <!-- ./ toolbar -->

    <!-- navigation drawer -->
    <v-navigation-drawer class="im-nav" absolute temporary v-model="drawer">
        <v-list class="pt-0">
            <v-list-item style="background-color: #2196f3" @click="drawer = !drawer">
                <v-list-item-action>
                    <v-icon color="white">account_balance</v-icon>
                </v-list-item-action>
                <v-list-item-content class="major white--text">
                    <v-list-item-title>Manager</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item :to="{path: '/dashboard'}">
                <v-list-item-action>
                    <v-icon>hotel</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/hotels'}">
                <v-list-item-action>
                    <v-icon>hotel</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Hotels</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/reservations'}">
                <v-list-item-action>
                    <v-icon>payment</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Reservations</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/invoices'}">
                <v-list-item-action>
                    <v-icon>table_chart</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Invoices</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/reports'}">
                <v-list-item-action>
                    <v-icon>poll</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Reports</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

    </v-navigation-drawer>
    <!-- ./ navigation drawer -->

    <!-- content -->
    <v-content :class="{app_content_desktop: $vuetify.breakpoint.mdAndUp, app_content_phone: $vuetify.breakpoint.smAndDown}">
        <v-fade-transition mode="out-in">
            <router-view class="im-container" :key="$route.fullPath" />
        </v-fade-transition>
    </v-content>
    <!-- ./ content -->

</div>
</template>

<script>
import IMProfile from '@imemento/spa-helpers/src/components/IMProfile/IMProfile.vue';
import IMAppSelector from '@imemento/spa-helpers/src/components/IMAppSelector/IMAppSelector.vue';
import IMLanguageSelector from '@imemento/spa-helpers/src/components/IMLanguageSelector/IMLanguageSelector.vue';

export default {
    components: {
        'im-profile': IMProfile,
        'im-app-selector': IMAppSelector,
        'im-language-selector': IMLanguageSelector
    },

    methods: {
        changeLocale(locale) {
            this.$vuetify.lang.current = locale;
        }
    },

    data() {
        return {
            drawer: false
        }
    }
}
</script>
